export type Params = { [name: string]: any };

export function createUrlSearchParams(params: Params): URLSearchParams {
  const urlSearchParams = new URLSearchParams();
  for (const name in params) {
    if (Array.isArray(params[name])) {
      for (const value of params[name]) {
        if (value) {
          urlSearchParams.append(name, value);
        }
      }
    } else if (params[name]) {
      urlSearchParams.set(name, params[name]);
    }
  }
  return urlSearchParams;
}
